var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getResizedImageUrl = (image, config) => {
  if (typeof image === "string")
    return image;
  if (!config)
    return;
  const { bucket, cloudFrontUrl, key } = image;
  if (!bucket || !cloudFrontUrl || !key)
    return image.url;
  const height = typeof config.height !== "undefined" ? Math.round(config.height) : void 0;
  const width = typeof config.width !== "undefined" ? Math.round(config.width) : void 0;
  const stringToEncode = JSON.stringify({
    bucket,
    key,
    edits: {
      resize: __spreadProps(__spreadValues({
        background: {
          r: 255,
          g: 255,
          b: 255,
          alpha: 1
        }
      }, config), {
        height,
        width
      })
    }
  });
  const buffer = Buffer.from(stringToEncode);
  const base64Params = buffer.toString("base64");
  return `${cloudFrontUrl}/${base64Params}`;
};

export { getResizedImageUrl };
//# sourceMappingURL=bundle.esm4.js.map
